import type { BuildMapLinkParams, LocationDescriptor } from './interfaces';

export const buildGoogleMapDirectionsLink = ({ origin, destination, waypoints }: BuildMapLinkParams) => {
  const baseUrl = `https://www.google.com/maps/dir/?api=1`;
  const params: string[] = [];

  if (origin.type === 'place') {
    params.push(`origin_place_id=${origin.placeId}`);
  } else {
    params.push(`origin=${buildLocationString(origin)}`);
  }

  if (destination.type === 'place') {
    params.push(`destination_place_id=${destination.placeId}`);
  } else {
    params.push(`destination=${buildLocationString(destination)}`);
  }

  if (waypoints?.length) {
    params.push(`waypoints=${waypoints.map(buildLocationString).join('|')}`);
  }

  return `${baseUrl}&${params.join('&')}`;
};

const buildLocationString = (location: LocationDescriptor) => {
  switch (location.type) {
    case 'coords':
      return `${location.latitude},${location.longitude}`;
    case 'address':
      return encodeURIComponent(location.address);
    case 'place':
      return `place_id:${location.placeId}`;
  }
};

namespace BuildGoogleMapsAddrssLink {
  export type Params = {
    address: string;
  };
}

export function buildGoogleMapsAddressLink({ address }: BuildGoogleMapsAddrssLink.Params) {
  const encoded = encodeURIComponent(address).replaceAll('%20', '+');
  return `https://www.google.com/maps/search/?api=1&query=${encoded}`;
}
